<div class="content-container" [class.content-open]="minigamesOpen">
    @if (loaderVisible) {
        <ds-loading-spinner class="loader-alignment" />
    }
    <iframe #casinoIframe class="mini-games-iframe" [src]="minigamesUrl | msTrust: 'resourceurl'"></iframe>
</div>
